import React from 'react';
import { Form, Badge } from 'react-bootstrap';
import { useLang } from "../../../contexts/LanguageContext";
import { useAuth } from "../../../contexts/AuthContext";

// Importar imágenes
import dialect_img from '../../../images/dialect.svg';
import audio_speed from '../../../images/audio-speed.svg';
import autoplay from '../../../images/autoplay.svg';

const dialectOptions = {
  'es_419': 'Español (latinoamérica)',
  'es_ES': 'Español'
};

function createSelectWithArray(options, name, onChange, value) {
  const size = Math.min(Math.max(Object.keys(options).length, 2), 5);
  return (
    <select name={name} className="settings-form-select" size={size} id={name} onChange={onChange} value={value}>
      {Object.entries(options).map(([value, label]) => (
        <option className="settings-menu-item" value={value} key={value}>
          {label}
        </option>
      ))}
    </select>
  );
}

export const AudioSettings = ({ preferences, onDialectChange, onSpeedChange, onAutoPlayChange, onChange }) => {
  const { t } = useLang();
  const { tier } = useAuth();
  const isFree = tier === 'free';

  const handleDialectChange = (e) => {
    onChange('dialectCode', e.target.value);
    onDialectChange(e.target.value);
  };

  const handleSpeedChange = (e) => {
    onChange('textSpeed', e.target.value);
    onSpeedChange(e.target.value);
  };

  const handleAutoPlayChange = (e) => {
    const val = e.target.checked ? 1 : 0;
    onChange('autoPlay', val);
    onAutoPlayChange(val === 1);
  };

  return (
    <>
      <div className="pb-5">
        <label htmlFor="dialectCode" className="settings-label"><img src={dialect_img} className="settingsLabelIcon" alt={t("CHAPTER_DIALECT_ICON")} />{t("CHAPTER_DIALECT")}</label>
        {createSelectWithArray(dialectOptions, "dialectCode", handleDialectChange, preferences.dialectCode)}
      </div>
      <div className="pb-5">
        <label htmlFor="speedSelect" className="settings-label">
          <img src={audio_speed} className="settingsLabelIcon" alt={t("CHAPTER_SPEED_ICON")} />
          {t("CHAPTER_SPEED")}
          {isFree && <Badge bg="warning" text="dark" className="ms-2" style={{ fontSize: '0.65em' }}>PREMIUM</Badge>}
        </label>
        <input name="textSpeed" type="range" className="form-range" min="0" max="4" list="tickmarks" id="speedSelect" onChange={handleSpeedChange} value={isFree ? 2 : preferences.textSpeed} disabled={isFree} />
        <datalist id="tickmarks">
          <option value="0" label="0.5x"></option>
          <option value="1" label="0.75x"></option>
          <option value="2" label="1x"></option>
          <option value="3" label="1.25x"></option>
          <option value="4" label="1.5x"></option>
        </datalist>
      </div>
      <div className="pb-5 container-fluid">
        <div className="row">
          <div className="col-10 p-0">
            <label htmlFor="autoPlay" className="settings-label">
              <img src={autoplay} className="settingsLabelIcon" alt={t("CHAPTER_AUTO_PLAY_ICON")}/>
              {t("CHAPTER_AUTO_PLAY")}
              {isFree && <Badge bg="warning" text="dark" className="ms-2" style={{ fontSize: '0.65em' }}>PREMIUM</Badge>}
            </label>
            <p className="settingsDesc">{t("CHAPTER_AUTO_PLAY_DESC")}</p>
          </div>
          <div className="col-2 form-check form-switch">
            <Form.Check 
              type="switch"
              id="autoPlay"
              name="autoPlay"
              onChange={handleAutoPlayChange}
              checked={isFree ? false : preferences.autoPlay}
              disabled={isFree}
            />
          </div>
        </div>
      </div>
    </>
  );
};
